import { $http } from '@/utils/https'

/**
 * Shared read-only dialog showing a single A/B submission
 * (Point A + Point B + AI analysis). Used by both the course-detail
 * sub-tab and the user-card A/B tab.
 *
 * Backend: GET admin/ab-forms/{id}?include=course
 */
export default {
	name: 'ab-form-detail-dialog',
	props: {
		value: {
			type   : Boolean,
			default: false
		},
		submissionId: {
			type   : [Number, String],
			default: null
		}
	},
	data () {
		return {
			loading: false,
			detail : null
		}
	},
	computed: {
		dialog: {
			get () {
				return this.value
			},
			set (val) {
				this.$emit('input', val)
			}
		},
		pointA () {
			return this.detail ? this.detail.point_a : null
		},
		pointB () {
			return this.detail ? this.detail.point_b : null
		},
		analysis () {
			return this.detail ? this.detail.analysis : null
		},
		course () {
			return this.detail && this.detail.course ? this.detail.course.data : null
		},
		fullName () {
			if (!this.detail) {
				return ''
			}

			return `${this.detail.first_name || ''} ${this.detail.last_name || ''}`.trim()
		}
	},
	watch: {
		value (visible) {
			if (visible && this.submissionId) {
				this.fetchDetail()
			}
		},
		submissionId (id) {
			if (this.value && id) {
				this.fetchDetail()
			}
		}
	},
	methods: {
		async fetchDetail () {
			this.detail = null

			try {
				this.loading = true

				const response = await $http.get(
					`${process.env.VUE_APP_ROOT_COURSE}ab-forms/${this.submissionId}?include=course`
				)

				this.detail = response.data.data
			} catch (e) {
				this.$toasted.error(this.$t('error') || 'Error')
			} finally {
				this.loading = false
			}
		},
		sentimentColor (sentiment) {
			switch (sentiment) {
				case 'positive':
					return 'success'
				case 'negative':
					return 'error'
				case 'neutral':
					return 'grey'
				default:
					return 'grey lighten-1'
			}
		},
		close () {
			this.dialog = false
		}
	}
}
